export default "__VITE_ASSET__ea577f95__"